import { Box, Button, Typography } from '@material-ui/core';
import React from 'react';
import { ServiceForm } from './components/ServiceForm';
import { ServicesTable } from './components/ServicesTable';

const Services: React.FC = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <Typography variant="h4">Serviços</Typography>
      <Typography>
        Os serviços cadastrados aparecerão como serviços disponíveis para que
        seus clientes possam reservar horários de atendimento
      </Typography>
      <Box py={2} display="flex" justifyContent="flex-end">
        <Button variant="contained" color="primary" onClick={handleClickOpen}>
          Novo serviço
        </Button>
      </Box>
      <ServicesTable />
      <ServiceForm open={open} handleClose={handleClose} />
    </Box>
  );
};

export { Services };
